import React, { useState, Fragment } from "react";

import { connect } from "react-redux";
import history from "../../history";

import { getFieldValue } from "../../helpers";

import { updateUserInProfileSilent } from "../../redux/actions";

import Button from "../../common/Button";
import * as style from "./styles.module.scss";

const CommunicationPreferences = ({ appData, updateProfile, loading }) => {
  if (!appData) return null;

  const [agreesToMailshot, setAgreesToMailshot] = useState(
    getFieldValue(appData, "agreesToMailshot")
  );

  const onSubmit = () => {
    const { candidateRef, emailAddress } = appData;
    const userData = {
      agreesToMailshot,
      candidateRef,
      emailAddress,
    };

    Promise.all([
      updateProfile(candidateRef, userData),
      history.push("/profile"),
    ]);
  };

  return (
    <Fragment>
      <div className={style.container}>
        <h2 className="section-header">Communication preferences</h2>
        <div>
          <div>
            <div>
              <p>
                Please contact me with information about new job opportunities,
                tips for improving my CV and interview performance, and other
                information from HRGO to help me with my job search via:
              </p>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={agreesToMailshot}
                  onChange={(e) => {
                    setAgreesToMailshot(e.target.checked);
                  }}
                  id="agreesToMailshot"
                />
                <label className="form-check-label" htmlFor="agreesToMailshot">
                  Email
                </label>
              </div>
            </div>
          </div>
          <div className="w-100 d-flex justify-content-end flex-column-reverse flex-sm-row">
            <Button
              styles={{ margin: "5px", minWidth: "175px !important" }}
              classes={`btn btn-outline-dark ${style.btn_backToMyAccount} `}
              onClick={() => history.push("/profile")}
            >
              Back to My Account
            </Button>
            <Button
              id="btnBasicInfoEditSubmit"
              classes="btn btn-primary"
              onClick={onSubmit}
              styles={{ margin: "5px" }}
            >
              {" "}
              {loading ? "Loading..." : "Save"}
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.core.user,
  appData: state.core.app,
  loading: state.core.loading,
});

const mapDispatchToProps = {
  updateProfile: updateUserInProfileSilent,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(CommunicationPreferences);
